import "./slider.scss";
import Swiper from "swiper/bundle";

class Slider {
  constructor(el, slides, sp, swipe, navigation) {
    this.el = el;
    this.slides = slides || 3;
    this.space = sp || 20;
    this.swipe = swipe !== false;
    this.navigation = navigation !== false;
    this.slider = null;
    this.create(); 
  }

  create() {
    // const next = this.el.querySelector(".next");
    // const prev = this.el.querySelector(".prev");

    const next = this.el.closest(".slider").querySelector(".next");
    const prev = this.el.closest(".slider").querySelector(".prev"); 

    const paginationEl = this.el.querySelector(".swiper-pagination");
    const scrollbarEl = this.el.querySelector(".swiper-scrollbar");

    const config = {
      slidesPerView: 1,
      spaceBetween: this.space,
      speed: 600,


      breakpoints: {
        1025: {
          slidesPerView: this.slides,
        },
        1024: {
          slidesPerView: this.slides - 1, 
        },
        768: {
          slidesPerView: this.slides - 2,
          allowTouchMove: this.swipe, 
        },
      },

      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
      },

      pagination: {
        el: paginationEl,
        type: "bullets",
        clickable: false,
      },

      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        
      }


    };

    if (this.navigation) {
      config.navigation = {
        nextEl: next,
        prevEl: prev,
      };
    }

    this.slider = new Swiper(this.el, config);
  }

  destroy() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }
}

var swiperSliders = [];

function initSlider() {
  const sliders = document.querySelectorAll(".slider");
  sliders.forEach((slider) => {
    const sliderSwiper = slider.querySelector(".swiper");
    const slides = slider.getAttribute("data-slides");
    const space = slider.getAttribute("data-space");
    const swipe = slider.getAttribute("data-swipe") !== "false";
    const navigation = slider.getAttribute("data-navigation") !== "false";
    const slsw = new Slider(sliderSwiper, slides, space, swipe, navigation);
    swiperSliders.push(slsw);
  });
}

function destroySlider() {
  swiperSliders.forEach((slider) => {
    slider?.destroy();
  });
  swiperSliders.length = 0;
}

export { Slider, initSlider, destroySlider };
